import React, { FC, useEffect, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InitialsSymbol from '../User/initialsSymbol';
import UserCard from './userCard';

interface ItemType {
  uuid: string;
  primary: string;
  secondary: string;
  members?: any[];
  initials: string;
  data?: any;
  color: string;
}

interface SelectTableProps {
  data: ItemType[];
  onSelect: (item: ItemType) => void;
  selected?: ItemType[];
  canEdit?: boolean;
  canDelete?: boolean;
  onEdit?: (item: any) => void;
  onDelete?: (item: any) => void;
  tooltip?: (item: ItemType) => JSX.Element;
}

const SelectTable: FC<SelectTableProps> = ({
  data,
  onSelect,
  selected,
  canEdit,
  canDelete = false,
  onEdit,
  onDelete,
  tooltip
}) => {
  const { t } = useTranslate();
  const [filteredData, setFilteredData] = useState(data);

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const search = e.target.value.toLowerCase();
    setFilteredData(
      data.filter(
        (item) =>
          item.primary.toLowerCase().includes(search) ||
          item.secondary.toLowerCase().includes(search)
      )
    );
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  return (
    <div className="p-3 border rounded border-secondary user-select-none">
      {/* Search Box */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control form-sm input-sm"
          placeholder={t('genericComponents.selectTable.search')}
          onChange={onSearch}
        />
      </div>
      <ul className="list-unstyled m-0">
        {filteredData.map((item) => (
          <li
            key={item.uuid}
            className="d-flex align-items-center justify-content-start py-2 cursor-pointer mb-2"
            onClick={() => {
              onSelect(item);
            }}
          >
            {/* Checkbox */}
            <div className="form-check form-check-sm form-check-custom form-check-solid me-4 cursor-pointer">
              <input
                className="form-check-input"
                type="checkbox"
                checked={selected?.map((i) => i?.uuid).includes(item?.uuid)}
                readOnly
              />
            </div>
            {/* Symbol (Avatar / Initials) */}
            <UserCard item={item} tooltip={tooltip} />

            {/* FontAwesome pen icon if user can edit */}
            <div className="ms-auto d-flex gap-3 align-items-center justify-content-end">
              {canEdit && (
                <i
                  className="fas fa-pen ms-auto cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(item.data);
                  }}
                />
              )}
              {canDelete && (
                <i
                  className="fa-duotone fa-solid fa-trash ms-auto cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(item.data);
                  }}
                />
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SelectTable;
